export default __webpack_public_path__ + "static/media/lovelockdown-artworkinfo3.59e82ce3.png";